enum TrainingContractErrorKey {
    NO_TRAINING_CONTRACT_FOUND_ERROR = "NoTrainingContractFoundException",
    TRAINING_CONTRACT_REGISTRATION_PAGE_NOT_ALLOWED = "TrainingContractRegistrationPageNotAllowed",
}

export default TrainingContractErrorKey;
